/**
 * Created by abbeymart on 2016-12-26.
 */
import type { RouteRecordRaw } from 'vue-router';

export const newsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/news',
    name: 'news',
    component: () => import('pages/central/common/McNews.vue'),
    meta: {
      title: 'Marketplace News',
    },
  },
];
